import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import { publicHttpClient } from '@/lib/httpClient';
import type { DefaultQueryError } from '../types';

export type AvailableCity = {
  _id: string;
  name: string;
  name_vi_vn: string;
};

type Params = {
  service_type: string;
  cityId?: string;
};

export const getAvailableCitiesFn = async (params?: Params) => {
  const response = await publicHttpClient.get<AvailableCity[]>(
    apiRoutes.services.available_cities,
    {
      params: {
        service_type: params?.service_type,
      },
    }
  );
  return response.data;
};

export const useGetAvailableCities = (
  params?: Params,
  opts?: UseQueryOptions<AvailableCity[], DefaultQueryError>
) =>
  useQuery<AvailableCity[], DefaultQueryError>(
    [apiRoutes.services.available_cities, params],
    () => getAvailableCitiesFn(params),
    opts
  );
